"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/* eslint @typescript-eslint/no-explicit-any: off */

function runtimeDetectProxiesProps(_ref) {
  var target = _ref.target,
    _ref$nonBrowserInstan = _ref.nonBrowserInstance,
    nonBrowserInstance = _ref$nonBrowserInstan === void 0 ? {} : _ref$nonBrowserInstan;
  var handler = {
    construct: function construct(OriginalTarget, args) {
      if (typeof document !== 'undefined') {
        return (0, _construct2["default"])(OriginalTarget, (0, _toConsumableArray2["default"])(args));
      }
      return nonBrowserInstance;
    }
  };
  return new Proxy(target, handler);
}
var _default = exports["default"] = runtimeDetectProxiesProps;